import Button from 'orionsoft-parts/lib/components/Button'
import React from 'react'
import styles from '../styles.css'
import download from './download'

export default function ExportConversation({conversationId}) {
  const handleClick = () => {
    try {
      download(
        {conversationId},
        'conversations/export-conversation',
        `conversacion-${conversationId}.xlsx`,
      )
    } catch (error) {
      console.log('Error', error)
    }
  }

  return (
    <div className={styles.content}>
      <Button primary onClick={handleClick}>
        Exportar conversación
      </Button>
    </div>
  )
}
